import 'babel-polyfill';
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index.js'
import axios from  './utils/axiosUtil'
import qs from 'qs';
import { CellSwipe, CellSwipeButton, Switch, NumberSpinner, Group, Picker, DatetimePicker, Circle } from 'we-vue';
import vueiInfinite from 'vue-infinite-scroll';
import * as util from '@static/js/util.js';
import Utils from './utils/utils'
import VueI18n from 'vue-i18n'
import VueVideoPlayer from 'vue-video-player'
import crop from './plugins/crop';
import gallery from './plugins/gallery';
import audio from './plugins/audio';
import VueClipboard from 'vue-clipboard2';
import toast from '@/components/include/toast/index'
import confirmDialog from './plugins/dialog/index'

import '../static/css/common.css';
import '../static/css/attach-icon.css';
import '../static/css/res-icon.css';
import '../static/css/swiper.min.css';

// zmf 20200223 重构代码
import basefun from './utils/baseFunction'
Vue.use(basefun)

Vue.use(CellSwipe).use(CellSwipeButton).use(Switch).use(NumberSpinner).use(Group).use(Picker).use(DatetimePicker).use(Circle);
Vue.use(vueiInfinite);
Vue.use(VueI18n) // 通过插件的形式挂载
Vue.use(VueVideoPlayer);
Vue.use(crop)
Vue.use(gallery)
Vue.use(audio)
Vue.use(VueClipboard)
Vue.use(toast)
Vue.use(confirmDialog)

Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$qs = qs
Vue.prototype.utils = Utils
Vue.prototype.util = util;

import global_variable from "@service/global_variable";
// import global_func from "@service/global_func";

Vue.prototype.GLOBAL = global_variable;
// Vue.use(global_func)

import AlloyFinger from 'alloyfinger'
import AlloyFingerPlugin from 'alloyfinger/vue/alloy_finger_vue'
Vue.use(AlloyFingerPlugin,{
	AlloyFinger
})

/****************************************************配置项目************************************************/
const i18n = new VueI18n({
	locale: 'zh-CN',    // 语言标识
	//this.$i18n.locale // 通过切换locale的值来实现语言切换
	messages: {
		'zh-CN': require('../static/lang/zh-CN'),   // 中文语言包
		'en-US': require('../static/lang/en-US')    // 英文语言包
	}
})

var debug = false;//如果是测试服务器，true
var url = '/config/app-config.json';
if(debug){
	url = './static/config/app-config.json';
}
/******************************************************************************f*****************************/

var GL_PREVIEW_KEY = 0; //预览服务

Vue.prototype.isWeixinBrowser = /micromessenger/.test(navigator.userAgent.toLowerCase());;

axios.get(url).then(function (response) {
    var packConfig = response.data;
    Vue.prototype.host      =packConfig.host;//服务端地址
    Vue.prototype.wxStuHost ='';//通过接口获取
    Vue.prototype.wxTwHost  ='';//通过接口获取
    Vue.prototype.imgUrl    =packConfig.imgUrl;//需要删除
    Vue.prototype.apiUrl    =packConfig.host + '/wx';
    Vue.prototype.stuApiUrl =packConfig.host + '/wx/student';
    Vue.prototype.twapiUrl  =packConfig.host + '/wx/teacher';
    Vue.prototype.appId     ='';//通过接口获取
    Vue.prototype.webHost   ='';//通过接口获取
    Vue.prototype.socketDomain = packConfig.socketDomain;
    Vue.prototype.socketHost=packConfig.socketHost;//由用户选择是否使用
    Vue.prototype.socketPort=packConfig.socketPort;//由用户选择是否使用

    axios.post(Vue.prototype.apiUrl + '/get-preview-state', qs.stringify({})).then(function (response) {
        var remoteConfig = response.data;
        if (remoteConfig.success) {
            GL_PREVIEW_KEY          =remoteConfig.data.previewKey;
            Vue.prototype.appId     =remoteConfig.data.appId;//通过接口获取
            Vue.prototype.webHost   =remoteConfig.data.host;//通过接口获取
            Vue.prototype.wxStuHost =remoteConfig.data.wxStuHost;
            Vue.prototype.wxTwHost  =remoteConfig.data.wxTwHost;
            Vue.prototype.apiUrl    =remoteConfig.data.wxStuHost + '/wx';
            Vue.prototype.stuApiUrl =remoteConfig.data.wxStuHost + '/wx/student';
            Vue.prototype.twapiUrl  =remoteConfig.data.wxTwHost + '/wx/teacher';
        }
        new Vue({
            el: '#app',
            i18n,  // 不要忘记
            router,
            store,
            components: { App },
            template: '<App/>'
        })
    }); //这里的res就是axios请求回来的结果
}); //这里的res就是axios请求回来的结果

Vue.prototype.$bus = new Vue();

var GL_COURSE_PAUSE = true; //是否暂停轮询 zmf 202009 初始一只轮训 default:true
var GL_COURSE_FORWARD_PAUSE = false; //是否暂停弹框提醒
var GL_QUIZ_ID = 0; //当前提问id
var GL_QUIZ_FREQUENCY = 0; //当前提问次数
var GL_DISCUSS_ID = 0; //当前讨论id
var GL_GROUP_ID = 0; //当前讨论id
var GL_COURSEWARE = null; //当前课讲
var GL_SIGN_STATUS = null; //当前签到状态，（暂未使用）
var GL_GROUPCASE = null; //当前分组方案， （暂未使用）
var GL_RUSHANSWER_ID = 0; //抢答id
var GL_CLICK_FLAG = false;//得分首页----我的分组是否微信端点击查询
var GL_CLASSING = false // 当前是否在上课

Vue.prototype.setIsClassing = function(isClassing) {
	GL_CLASSING = isClassing;
};

Vue.prototype.isClassing = function() {
	return GL_CLASSING;
};

Vue.prototype.setAppId = function(appId) {
    Vue.prototype.appId = appId;
};
Vue.prototype.setWebHost = function(webHost) {
    Vue.prototype.webHost = webHost;
};

Vue.prototype.getPreviewKey = function() {
    return GL_PREVIEW_KEY;
};
Vue.prototype.setPreviewKey = function(previewKey) {
    GL_PREVIEW_KEY = previewKey;
};

Vue.prototype.isLoopPaused = function() {
    return GL_COURSE_PAUSE;
};
Vue.prototype.isForwardPaused = function() {
    return GL_COURSE_FORWARD_PAUSE;
};

Vue.prototype.pauseLoop = function() {
    GL_COURSE_PAUSE = true;
};
Vue.prototype.startLoop = function() {
	//alert("设置停止按钮" + GL_COURSE_PAUSE);
    GL_COURSE_PAUSE = false;
};

Vue.prototype.pauseForward = function() {
    GL_COURSE_FORWARD_PAUSE = true;
};
Vue.prototype.startForward = function() {
    GL_COURSE_FORWARD_PAUSE = false;
};

Vue.prototype.getCurrCourseware = function() {
    return GL_COURSEWARE;
};
Vue.prototype.setCurrCourseware = function(newCourseware) {
    GL_COURSEWARE = newCourseware;
};

Vue.prototype.getCurrGroupCase = function() {
    return GL_GROUPCASE;
};
Vue.prototype.setCurrGroupCase = function(newGroupCase) {
    GL_GROUPCASE = newGroupCase;
};

Vue.prototype.getSignStatus = function() {
    return GL_SIGN_STATUS;
};

Vue.prototype.setQuizId = function(newQuizId) {
    GL_QUIZ_ID = newQuizId;
};
Vue.prototype.getQuizId = function() {
    return GL_QUIZ_ID;
};

Vue.prototype.setQuizFrequency = function(frequency) {
    GL_QUIZ_FREQUENCY = frequency;
};
Vue.prototype.getQuizFrequency = function() {
    return GL_QUIZ_FREQUENCY;
};

Vue.prototype.setRushAnswerId = function(rushAnswerId) {
    GL_RUSHANSWER_ID = rushAnswerId;
};
Vue.prototype.getRushAnswerId = function() {
    return GL_RUSHANSWER_ID;
};
Vue.prototype.setGroupId = function(newGroupId) {
	GL_GROUP_ID = newGroupId;
};
Vue.prototype.getGroupId = function() {
	return GL_GROUP_ID;
};
Vue.prototype.setDiscussId = function(newDiscussId) {
    GL_DISCUSS_ID = newDiscussId;
};
Vue.prototype.getDiscussId = function() {
    return GL_DISCUSS_ID;
};
Vue.prototype.setClickFlag = function(flag) {
	GL_CLICK_FLAG = flag;
};
Vue.prototype.getClickFlag = function() {
	return GL_CLICK_FLAG;
};

Vue.prototype.getFileType = function(url) {
    return util.getFileType(url);
};

// 注册一个全局自定义指令 `v-checkParam`
Vue.directive('checkParam', {
    // 当被绑定的元素插入到 DOM 中时……
    inserted: function(el, binding, vNode) {
        el.addEventListener('keyup', function(event) {
            // 首先去除已有样式
            el.className = el.className.replace('input-error', '').trim()
            if (!event.keyCode) { // 加上这个判断就是在提交时，才会校验
                // 判断是否是否必填
                let isRequired = binding.value.required;
                let msg = binding.value.msg;
                if (isRequired) {
                    if (!el.value || el.value === '') {
                        weui.alert(msg + '不能为空');
                        el.className += ' input-error';
                    }
                }
            }
        })
    }
});
//注册全局过滤器
Vue.filter('getTaskTypeStr', function(type) {
    var typeOptions = {
        "10": '预习',
        "20": '个人作业',
        "21": '小组作业',
        "30": '小组研讨'
    };
    return typeOptions[type] || '任务';
})
// 注册一个全局自定义指令 `v-checkSubmit`
Vue.directive('checkSubmit', {
    // 当被绑定的元素插入到 DOM 中时……
    inserted: function(el, binding, vNode) {
        el.addEventListener('click', function(event) {
            let elements = document.getElementsByClassName('v-check')
            var evObj = document.createEvent('Event')
            evObj.initEvent('keyup', true, true)
            for (let element of elements) {
                element.dispatchEvent(evObj);
                if (!element.value || element.value === '') {
                    //   weui.alert(msg+'不能为空');
                    element.className += ' input-error';
                }
            }
            let errorInputs = document.getElementsByClassName('input-error');
            if (errorInputs.length === 0) {
                vNode.context.save();
            } else {
                event.stopPropagation();
                return;
            }
        });
    }
});



// WEBPACK FOOTER //
// ./src/main.js